import { AfterViewInit, Directive, ElementRef, Inject, PLATFORM_ID, Self } from '@angular/core';
import { isPlatformServer } from '@angular/common';

@Directive({
  selector: '[appAutoFocus]',
  standalone: true,
})
export class AutoFocusDirective implements AfterViewInit {
  constructor(
    @Self() private host: ElementRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.host.nativeElement.focus();
  }
}
